import React from "react";
import styled from "styled-components";
import { Loader } from "./Loader";

export const ButtonComp = ({
  textcard,
  handleAction,
  isLoading,
  color,
  background,
  disabled,
}) => {
  return handleAction ? (
    <PublicButtonWrapper
      onClick={!disabled ? handleAction : undefined}
      color={color}
      background={background}
    >
      {isLoading ? (
        <Loader size={24} color={"#688540"} />
      ) : (
        <button
          className="bg-green-theme hover:bg-green-theme-dark transition-colors"
          type="submit"
          disabled={disabled || isLoading}
        >
          {textcard}
        </button>
      )}
    </PublicButtonWrapper>
  ) : (
    <PublicButtonWrapper color={color} background={background}>
      {isLoading ? (
        <Loader size={24} color={"#688540"} />
      ) : (
        <button
          className="bg-green-theme hover:bg-green-theme-dark transition-colors"
          type="submit"
          disabled={disabled || isLoading}
        >
          {textcard}
        </button>
      )}
    </PublicButtonWrapper>
  );
};

const PublicButtonWrapper = styled.div`
  width: 100%;
  button {
    width: 100%;
    padding: 15px;
    border-radius: 8px;
    text-align: center;
    /* background: ${({ background }) =>
    background ? background : "#3d97f2"}; */
    color: ${({ color }) => (color ? color : "#fff")};
    font-family: Lato, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border-style: none;
    letter-spacing: -0.01em;
    cursor: pointer;
    &:hover {
      box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.16);
    }
    &:disabled {
      cursor: not-allowed;
      background-color: #696969;
      opacity: 0.5;
    }
  }

  div {
    width: 100%;
    padding: 15px;
    background: transparent;
    border-radius: 8px;
    text-align: center;
    color: #ffff;
    font-family: Lato, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    border-style: none;
    letter-spacing: -0.01em;
    cursor: pointer;
  }
`;
